import { DownOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Button, Dropdown, Form, MenuProps, Space } from 'antd';
import { FC, useEffect, useState } from 'react';
import IconFont from './IconFont';
import styles from './index.less';
import { ENodeType } from '@/pages/backend/cardCampSettings/nodeSettings/enum';
import NodeComponent from '@/pages/backend/cardCampSettings/nodeSettings/nodeComponent';
import DragList from '@/pages/backend/cardCampSettings/nodeSettings/DragList';
import { MenuItemType } from 'antd/es/menu/interface';
import { filter, flatten, isEmpty, isEqual, padStart } from 'lodash';
import { useUpdateEffect } from 'ahooks';
import { create32LengthUUID } from '@/utils/index';

export type TDataSourceType = {
  name: string;
  id: string;
  type: ENodeType;
  index: number;
  info: { contentInfo: any };
};

const NodeContentList: FC<{ data?: TDataSourceType[] }> = ({ data }) => {
  const form = Form.useFormInstance();
  const [disabledDrag, setDisabledDrag] = useState(false);
  const contentInfoMappingValue = form.getFieldValue('contentInfoMapping');
  const [dataSource, setDataSource] = useState<TDataSourceType[]>([]);
  const items: MenuProps['items'] = [
    {
      label: '富文本',
      key: ENodeType.richtext,
      icon: <IconFont type="icon-u638" />,
    },
    {
      label: '视频',
      key: ENodeType.video,
      icon: <IconFont type="icon-u650" />,
    },
    {
      label: '习题',
      key: ENodeType.exercise,
      icon: <IconFont type="icon-u291" />,
    },
    {
      label: '职业认证',
      key: ENodeType.certification,
      icon: <IconFont type="icon-u294" />,
    },
  ];
  useUpdateEffect(() => {
    form.setFieldsValue({ contents: dataSource });
  }, [dataSource]);
  useEffect(() => {
    if (Array.isArray(data)) {
      setDataSource(data);
    } else {
      setDataSource([]);
    }
  }, [data]);
  return (
    <div>
      <Form.Item name="contents" hidden />
      <Space className="mb-[16px]">
        <Dropdown
          menu={{
            items,
            onClick: (e) => {
              const { key } = e;
              const numberKey = Number(key);
              const findItem = items?.find((item) => item?.key === numberKey);
              console.log(e);
              if (findItem) {
                setDataSource((prevState) => {
                  const name = `${(findItem as MenuItemType).label}${padStart(
                    String(dataSource.length + 1),
                    2,
                    '0',
                  )}`;
                  const id = create32LengthUUID();
                  prevState.push({
                    id,
                    name,
                    type: numberKey,
                    index: prevState.length,
                    info: { contentInfo: undefined },
                  });
                  return [...prevState];
                });
              }
            },
          }}
          overlayClassName={styles.node_settings_dropdown}
        >
          <Button icon={<PlusSquareOutlined />} type="primary">
            <Space>
              添加
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
        <div className="text-c0c0c0" style={{ lineHeight: '32px' }}>
          上下拖拽可对节点模块进行排序
        </div>
      </Space>
      <DragList<TDataSourceType>
        data={dataSource}
        disabled={disabledDrag}
        component={(item) => {
          return (
            <Form.Item
              name={['contentInfoMapping', item.id]}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  validator: (_, value) => {
                    console.log('value检查', value);
                    if (
                      isEmpty(flatten(filter(value))) ||
                      isEqual(
                        {
                          richText:
                            '{"type":"doc","content":[{"type":"paragraph","attrs":{"align":"left","indent":0,"firstLineIndent":null}}]}',
                        },
                        value,
                      )
                    ) {
                      return Promise.reject('请维护打卡节点内容');
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <NodeComponent
                toggleFullScreen={(isFullScreen) => {
                  setDisabledDrag(isFullScreen);
                }}
                defaultValue={contentInfoMappingValue?.[item.id]}
                // defaultValue={item?.info?.contentInfo}
                id={item.id}
                onDelete={(id) => {
                  const idx = dataSource.findIndex((item) => item.id === id);
                  if (idx > -1) {
                    setDataSource((prevState) => {
                      prevState.splice(idx, 1);
                      return [...prevState];
                    });
                  }
                }}
                //className="mb-[16px]"
                type={item.type}
                name={item.name}
                onNameChange={(id, name) => {
                  const idx = dataSource.findIndex((item) => item.id === id);
                  if (idx > -1) {
                    setDataSource((prevState) => {
                      prevState.splice(idx, 1, { ...dataSource[idx], name });
                      return [...prevState];
                    });
                  }
                  return true;
                }}
              />
            </Form.Item>
          );
        }}
        onDragEnd={(data) => {
          const temp = [];
          for (let i = 0; i < data.length; i++) {
            const id = data[i].id;
            const find = dataSource.find((item) => item.id === id);
            if (find) {
              find.index = i;
              temp.push(find);
            }
          }
          form.setFieldsValue({ contents: temp });
        }}
      />
    </div>
  );
};
export default NodeContentList;
